import React from 'react'
import PropTypes from 'prop-types'

import ListingCard from 'Pages/CompareListings/components/ListingCard'

import {
  _ListingRow,
} from './styles'

const ListingRow = ({
  comparedListings, removeCompareListing, userIsAuthentificated,
  openRegisterModal, googleAnalyticsEvent,
}) => {
  const listingArray = [1, 2, 3, 4, 5]
  Object.keys(comparedListings).forEach((mlsNumber, index) => {
    const listing = comparedListings[mlsNumber]
    listingArray[index] = listing
  })

  return (
    <_ListingRow className="scroll-container">
      {
        listingArray.map(listing => (
          <ListingCard
            key={listing.id || listing}
            listing={listing}
            removeCompareListing={removeCompareListing}
            userIsAuthentificated={userIsAuthentificated}
            openRegisterModal={openRegisterModal}
            googleAnalyticsEvent={googleAnalyticsEvent}
          />
        ))
      }
    </_ListingRow>
  )
}

ListingRow.propTypes = {
  comparedListings: PropTypes.shape({}),
  removeCompareListing: PropTypes.func,
  userIsAuthentificated: PropTypes.bool,
  openRegisterModal: PropTypes.func,
  googleAnalyticsEvent: PropTypes.func,
}

export default ListingRow
